import React from 'react';
import './Metrics.css'

const Metrics = () => {
    return (
        <>
            <div className="metrics-card card-4">
                <div className="header">
                    <span>+40</span>
                </div>
                <p className="heading">Años de experiencia</p>
                <div className="footer">
                    A lo largo de nuestra trayectoria, hemos construido una sólida reputación basada en la confianza mutua, la calidad del servicio y la atención personalizada.
                </div>
            </div>

            <div className="metrics-card card-2">
                <div className="header">
                    <span>+2000</span>
                </div>
                <p className="heading">Clientes satisfechos</p>
                <div className="footer">
                    Basándonos en la búsqueda de soluciones personalizadas y atención prioritaria, garantizamos la protección de las familias, bienes y futuro de los colombianos.
                </div>
            </div>

            <div className="metrics-card card-1">
                <div className="header">
                    <span>+12</span>
                </div>
                <p className="heading">Aliados estratégicos</p>
                <div className="footer">
                    Gracias a nuestra amplia red, ofrecemos una extensa gama de productos y servicios que se ajustan a los requerimientos de cada cliente.
                </div>
            </div>

            <div className="metrics-card card-3">
                <div className="header">
                    <span>+20</span>
                </div>
                <p className="heading">Productos</p>
                <div className="footer">
                    Nuestros seguros están diseñados para satisfacer las necesidades de nuestros clientes individuales, grupos familiares y asociaciones empresariales.
                </div>
            </div>
        </>
    );
};

export default Metrics;
